import Slider from '../../UIKitRefresh/Slider/Slider';

const formatNumber = (value) => Math.round(value);

class NavigationCityRadius {
  constructor(tag, options = {}) {
    this.root = document.querySelector(`[data-city-radius="${tag}"]`);
    if (!this.root) return;
    this.parentNode = document.querySelector(`[data-uipopup-trigger="${tag}"]`);
    this.labelsNodes = [...this.parentNode.querySelectorAll('[data-realty-type]')];
    this.realtyTypeNodes = [...this.root.querySelectorAll('[data-realty-type]')];
    this.sliders = this.nodesByRealtyType('data-slider');
    this.slidersToReset = this.nodesByRealtyType();
    this.labels = this.labelsByRealtyType();
    this.onAssign = options.onAssign;
    this.onReset = options.onReset;

    this.attachSlider();
  }

  nodesByRealtyType(key) {
    return this.realtyTypeNodes.reduce((acc, node) => {
      return {
        ...acc,
        [node.dataset.realtyType]: key ? [...node.querySelectorAll(`[${key}]`)] : [],
      };
    }, {});
  }

  labelsByRealtyType() {
    return this.labelsNodes.reduce((acc, node) => {
      return {
        ...acc,
        [node.dataset.realtyType]: node,
      };
    }, {});
  }

  attachSlider() {
    Object.entries(this.sliders).forEach(([realtyType, sliders]) => {
      sliders.forEach((node) => {
        const sliderNode = node.querySelector('[data-slider-initial]');
        const valueNode = node.querySelector('[data-value]');

        const slider = new Slider(sliderNode, ['radius'], {
          onUpdate: (value) => {
            const label = `+ ${formatNumber(value)} км`;

            valueNode.textContent = label;
            this.labels[realtyType].textContent = label;
          },
          onChange: (key, value) => {
            this.onAssign('radius', formatNumber(value), true);
          },
          step: 5,
        });
        this.slidersToReset[realtyType].push(slider);
      });
    });
  }

  updateRealtyType() {
    if (!this.root) return;
    // update visible slider
    this.realtyTypeNodes.forEach((realtyType) => realtyType.classList.add('hidden'));
    this.root
      .querySelector(`[data-realty-type="${window.params.buildingType}"]`)
      ?.classList.remove('hidden');
    // update visible label in NavigationCitySelect
    this.labelsNodes.forEach((label) => label.classList.add('hidden'));
    this.parentNode
      .querySelector(`[data-realty-type="${window.params.buildingType}"]`)
      ?.classList.remove('hidden');
    this.reset();
  }

  reset() {
    Object.values(this.slidersToReset).forEach((sliders) => {
      sliders.forEach((slider) => {
        slider.reset();
      });
    });
    this.onReset({ radius: null }, true);
  }
}

export default NavigationCityRadius;
